interface Props {
    errorMessage?: string
}

export default function ErrorFetch({errorMessage = 'Error fetching'}: Props) {
    return (
        <div className='flex items-center justify-center h-auto w-full'>
            <p className='text-black text-xs'>{errorMessage}</p>
        </div>
    )
}